export default {
    getterSelectedWorkerName: ({ workerDetail }) => {
        const workerName = workerDetail?.name;
        if (!workerName) {
            return '-';
        }
        return workerName;
    },
    getterSelectedWorkerHubId: ({ workerDetail }) => workerDetail?.hubId,
    getterSelectedWorkerDetailDeliveryFeeGroup: ({ workerDetail }) => workerDetail?._workerDeliveryFeeGroupDTO,
    getterSelectedWorkerDetailCashAutoDeductGroup: ({ workerDetail }) => workerDetail?._workerCashAutoDeductGroupDTO,
    getterSelectedWorkerDetailAllocatedCancelPenaltyGroup: ({ workerDetail, }) => workerDetail?._workerPenaltyGroupDTO,
};
